import { PayloadAction } from '@reduxjs/toolkit';

import { getAllSizes } from 'productTemplate/utils/getAllSizes';
import { getAvailableSizesPrioritizedByCondition } from 'shared/utils/getLowestPriceVariantsPrioritizedByCondtion';
import { getNewAvailableSizes } from 'productTemplate/utils/getNewAvailableSizes';
import { getSizeOptionsMap } from 'productTemplate/utils/getSizeOptionsMap';

import { IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';
import { IConsumerSearchFactsWindowData } from 'productTemplate/types/FactsWindowData';
import { IExperimentState, IExperimentGroup } from 'store/types/experimentTypes';
import { IFeaturedInCollection } from 'productTemplate/types/FeaturedInCollection';
import { IPdp } from 'store/types/pdpTypes';
import { IProductTemplate } from 'shared/types/ProductTemplate';
import { IWant } from 'shared/types/Want';

export const setProductTemplateData = (
  state: IPdp,
  action: PayloadAction<{
    productTemplate: IProductTemplate;
    factsWindowData: IConsumerSearchFactsWindowData;
    featuredInCollections: IFeaturedInCollection[];
  }>,
) => {
  const { productTemplate, factsWindowData, featuredInCollections } = action?.payload;
  if (productTemplate) {
    state.productTemplate = productTemplate;
  }

  if (factsWindowData) {
    state.factsWindowData = factsWindowData;
  }

  if (featuredInCollections) {
    state.featuredInCollections = featuredInCollections;
  }
};

export const setUserWants = (state: IPdp, action: PayloadAction<IWant[]>) => {
  state.userWants = action.payload;
};

export const setTempUserWant = (state: IPdp, action: PayloadAction<number>) => {
  state.tempUserWantSize = action.payload;
};

export const clearTempUserWant = (state: IPdp) => {
  state.tempUserWantSize = null;
};

export const setIsWantsWindowOpen = (state: IPdp, action: PayloadAction<boolean>) => {
  state.isWantsWindowOpen = action.payload;
};

export const setBuyBarVariants = (state: IPdp, action: PayloadAction<IBuyBarProductVariant[]>) => {
  const buyBarData = action.payload;
  const { sizeOptions } = state.productTemplate;

  const sizeOptionsMap = getSizeOptionsMap(sizeOptions);
  const { availableSizes, mapSizeToVariants, usedVariant } =
    getAvailableSizesPrioritizedByCondition(buyBarData, false, sizeOptionsMap);

  state.buyBarVariants.allSizes = getAllSizes(sizeOptions, availableSizes);
  state.buyBarVariants.availableSizes = availableSizes;
  state.buyBarVariants.newAvailableSizes = getNewAvailableSizes(buyBarData);
  state.buyBarVariants.usedAvailableSizes = usedVariant;
  state.buyBarVariants.mapSizeToVariants = mapSizeToVariants;
};

export const setExperimentsMap = (
  state: IExperimentState,
  action: PayloadAction<{
    [key: string]: { experimentGroup?: IExperimentGroup };
  }>,
) => {
  state.experimentsMap = action.payload;
};
